export default __webpack_public_path__ + "static/media/README.2a857c4a.md";